import React, { useState } from 'react';
import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import logo from '../assets/logo.png';

const Icons = {
  home: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M3 9.5L12 3l9 6.5V20a1 1 0 01-1 1H4a1 1 0 01-1-1V9.5z"/><path d="M9 21V12h6v9"/></svg>,
  calendar: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><rect x="3" y="4" width="18" height="18" rx="2"/><path d="M16 2v4M8 2v4M3 10h18"/></svg>,
  plus: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><circle cx="12" cy="12" r="9"/><path d="M12 8v8M8 12h8"/></svg>,
  team: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75"/></svg>,
  settings: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 010 2.83 2 2 0 01-2.83 0l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 01-4 0v-.09A1.65 1.65 0 009 19.4a1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 01-2.83-2.83l.06-.06A1.65 1.65 0 004.68 15a1.65 1.65 0 00-1.51-1H3a2 2 0 010-4h.09A1.65 1.65 0 004.6 9a1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 012.83-2.83l.06.06A1.65 1.65 0 009 4.68a1.65 1.65 0 001-1.51V3a2 2 0 014 0v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 012.83 2.83l-.06.06A1.65 1.65 0 0019.4 9a1.65 1.65 0 001.51 1H21a2 2 0 010 4h-.09a1.65 1.65 0 00-1.51 1z"/></svg>,
  lock: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0110 0v4"/></svg>,
  check: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M9 11l3 3L22 4"/><path d="M21 12v7a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h11"/></svg>,
  doc: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><path d="M14 2v6h6M16 13H8M16 17H8M10 9H8"/></svg>,
  briefcase: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><rect x="2" y="7" width="20" height="14" rx="2"/><path d="M16 21V5a2 2 0 00-2-2h-4a2 2 0 00-2 2v16"/></svg>,
  userPlus: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M16 21v-2a4 4 0 00-4-4H6a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M19 8v6M22 11h-6"/></svg>,
  box: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M21 8l-9-5-9 5v8l9 5 9-5V8z"/><path d="M3 8l9 5 9-5M12 13v8"/></svg>,
  contacts: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="12" cy="10" r="3"/><path d="M7 18a5 5 0 0110 0"/></svg>,
  folder: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M22 19a2 2 0 01-2 2H4a2 2 0 01-2-2V5a2 2 0 012-2h5l2 3h9a2 2 0 012 2z"/></svg>,
  chart: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M3 3v18h18"/><path d="M7 15l4-4 3 3 6-6"/></svg>,
  menu: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M3 12h18M3 6h18M3 18h18"/></svg>,
  close: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M18 6L6 18M6 6l12 12"/></svg>,
};

const Layout = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  const initials = user?.name?.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2) || '?';
  const roleLabel = user?.role === 'admin' ? 'Administrator' : user?.role === 'director' ? 'Director' : user?.role === 'recruit' ? 'New Starter' : 'Staff';
  const isRecruit = user?.role === 'recruit';
  const isManager = ['director', 'admin'].includes(user?.role);

  const handleLogout = () => { logout(); navigate('/login'); };
  const closeMenu = () => setMenuOpen(false);
  const linkClass = ({ isActive }) => `nav-link ${isActive ? 'active' : ''}`;

  const NavItems = () => (
    <>
      {isRecruit ? (
        <>
          <div className="nav-section-label">Onboarding</div>
          <NavLink to="/onboarding" className={linkClass} onClick={closeMenu}>{Icons.check} My Onboarding</NavLink>
          <NavLink to="/company-documents" className={linkClass} onClick={closeMenu}>{Icons.doc} Company Documents</NavLink>
        </>
      ) : (
        <>
          <div className="nav-section-label">My Portal</div>
          <NavLink to="/" end className={linkClass} onClick={closeMenu}>{Icons.home} Dashboard</NavLink>
          <NavLink to="/my-holidays" className={linkClass} onClick={closeMenu}>{Icons.calendar} My Holidays</NavLink>
          <NavLink to="/request" className={linkClass} onClick={closeMenu}>{Icons.plus} Request Absence</NavLink>
          <NavLink to="/team-calendar" className={linkClass} onClick={closeMenu}>{Icons.team} Team Calendar</NavLink>
          {user?.can_stock_take && (
            <NavLink to="/stock-take" className={linkClass} onClick={closeMenu}>{Icons.box} Stock Take</NavLink>
          )}
          {user?.can_sales_board && (
            <NavLink to="/sales-board" className={linkClass} onClick={closeMenu}>{Icons.chart} Sales Board</NavLink>
          )}
          <NavLink to="/my-documents" className={linkClass} onClick={closeMenu}>{Icons.folder} My Documents</NavLink>
          <NavLink to="/company-documents" className={linkClass} onClick={closeMenu}>{Icons.doc} Company Documents</NavLink>
        </>
      )}

      {!isRecruit && (user?.can_use_crm || user?.can_insights) && (
        <>
          <div className="nav-section-label" style={{marginTop: 8}}>CRM</div>
          {user?.can_use_crm && <NavLink to="/crm" end className={linkClass} onClick={closeMenu}>{Icons.contacts} Customers</NavLink>}
          {user?.can_use_crm && <NavLink to="/crm/follow-ups" className={linkClass} onClick={closeMenu}>{Icons.check} Follow-ups</NavLink>}
          {user?.can_insights && <NavLink to="/crm/insights" className={linkClass} onClick={closeMenu}>{Icons.chart} Insights</NavLink>}
        </>
      )}

      {isManager && (
        <>
          <div className="nav-section-label" style={{marginTop: 8}}>Management</div>
          <NavLink to="/director" className={linkClass} onClick={closeMenu}>{Icons.home} Overview</NavLink>
          <NavLink to="/manage-requests" className={linkClass} onClick={closeMenu}>{Icons.check} Manage Requests</NavLink>
          <div className="nav-section-label" style={{marginTop: 8}}>Recruitment</div>
          <NavLink to="/recruitment" className={linkClass} onClick={closeMenu}>{Icons.briefcase} Candidates</NavLink>
          <NavLink to="/recruits" className={linkClass} onClick={closeMenu}>{Icons.userPlus} Onboarding</NavLink>
        </>
      )}

      {user?.role === 'admin' && (
        <>
          <div className="nav-section-label" style={{marginTop: 8}}>Admin</div>
          <NavLink to="/admin/users" className={linkClass} onClick={closeMenu}>{Icons.settings} Manage Staff</NavLink>
        </>
      )}

      <div className="nav-section-label" style={{marginTop: 8}}>Account</div>
      <NavLink to="/change-password" className={linkClass} onClick={closeMenu}>{Icons.lock} Change Password</NavLink>
    </>
  );

  return (
    <div className="app-shell">
      {/* Mobile top bar */}
      <div className="mobile-topbar">
        <div style={{ background: 'var(--white)', borderRadius: '4px', padding: '5px 10px', display: 'flex', alignItems: 'center' }}>
          <img src={logo} alt="Tranzparts Group Limited" style={{ height: '26px', objectFit: 'contain', display: 'block' }} />
        </div>
        <button className="mobile-menu-btn" onClick={() => setMenuOpen(!menuOpen)}>
          {menuOpen ? Icons.close : Icons.menu}
        </button>
      </div>

      {menuOpen && <div className="mobile-overlay" onClick={closeMenu} />}

      <aside className={`sidebar ${menuOpen ? 'sidebar-open' : ''}`}>
        <div className="sidebar-logo" style={{ flexDirection: 'column', alignItems: 'stretch', gap: '10px' }}>
          <div style={{ background: 'var(--white)', borderRadius: '6px', padding: '12px 14px' }}>
            <img src={logo} alt="Tranzparts Group Limited" style={{ width: '100%', objectFit: 'contain', display: 'block' }} />
          </div>
          <span className="sidebar-logo-sub" style={{ textAlign: 'center' }}>Staff Portal</span>
        </div>
        <nav className="sidebar-nav"><NavItems /></nav>
        <div className="sidebar-footer">
          <div className="sidebar-user">
            <div className="sidebar-avatar">{initials}</div>
            <div className="sidebar-user-info">
              <div className="sidebar-user-name">{user?.name}</div>
              <div className="sidebar-user-role">{roleLabel}</div>
            </div>
          </div>
          <button className="logout-btn" onClick={handleLogout}>Sign Out</button>
        </div>
      </aside>

      <main className="main-content"><Outlet /></main>
    </div>
  );
};

export default Layout;
